import React, { Component, forwardRef } from 'react'
import './styles/textInput.scss'
import {runByFeature} from './utils/runByFeature'

class TextInput extends Component {
  constructor (props) {
    super(props)

    this.typingTimer = null

    this.features = props.features

    this.state = {
      inputValue: '',
      type: '',
      value: ''
    }
  }

  componentDidMount() {
    const { schema, value } = this.props

    let type = ((schema.minimum) || (schema.maximum))
      ? 'number'
      : schema.type
        ? schema.type
        : 'string'

    const valueByType = value
      ? (type === 'string'
        ? value.toString()
        : Number(value))
      : ''

    this.setState({
      inputValue: valueByType,
      type
    })
  }

  componentWillUnmount() {
    clearTimeout(this.typingTimer)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevValue = typeof prevProps.value === 'string' && this.state.type === 'number' ? parseInt(prevProps.value) : prevProps.value
    const currentValue = typeof this.props.value === 'string' && this.state.type === 'number' ? parseInt(this.props.value) : this.props.value
    const changeCondition = this.state.type === 'number'
        ? !isNaN(prevValue) && !isNaN(currentValue) && prevValue !== currentValue && currentValue !== this.state.value
        : prevValue !== currentValue && currentValue !== this.state.value

    if (changeCondition) {
      this.onInputChanged({target: {value: this.props.value}}, true)
    } else if (prevValue !== '' && currentValue === '' && prevValue !== currentValue && currentValue !== this.state.value) {
      this.onInputChanged({target: {value: ''}})
    }
  }

  onInputChanged = (e, skipOnChange) => {
    const newValue = e.target.value
    const isNumber = !isNaN(parseInt(newValue))

    const parsedValue = (this.state.type === 'number') && newValue && isNumber ? Number(newValue) : newValue
    this.setState({
      inputValue: parsedValue,
      value: parsedValue
    })

    if (skipOnChange) {
      return
    }
    clearTimeout(this.typingTimer)
    this.typingTimer = setTimeout(() => {
      this.props.onChange(parsedValue)
    }, 750)
  }

  handleOnBlur = () => {
    this.props.onChange(this.state.inputValue)
  }

  render () {
    const { options = {
      custom: { multiline: false },
      readonly: false
    },
      disabled,
      innerRef,
      readonly,
      required
    } = this.props

    const { inputValue, type } = this.state

    return (
      <div>
        {options.custom.multiline
          ? <textarea
            required={required}
            onChange={this.onInputChanged}
            className='text-input-duc form-control'
            value={inputValue}
            disabled={readonly || options.readonly || disabled}
            onBlur={this.handleOnBlur}
            ref={innerRef}
          />
          : <input
                type={runByFeature(this.features, {
                  newStaticProduct: () => '',
                  otherwise: () => type
                })}
            required={required}
            onChange={this.onInputChanged}
            className='text-input-duc form-control'
            value={inputValue}
            disabled={readonly || options.readonly || disabled}
            onBlur={this.handleOnBlur}
            ref={innerRef}
          />
        }
      </div>
    )
  }
}

const TextInputForwardingRef = forwardRef((props, ref) => {
  return <TextInput {...props} innerRef={ref}/>
})

if (typeof window !== 'undefined') {
  window.uStoreDucs = window.uStoreDucs || []
  window.uStoreDucs.push({ name: 'textInput', component: TextInputForwardingRef, displayNames: ['Multiline Text Input','Text Input','Get Order Properties'] })
}

export default TextInputForwardingRef
